/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import Emitter from '../../bus';
import { setUserDetails } from '../../services/user/setUserDetails';
import { setUserFavorites } from '../../services/aws/user/setAttributes/setUserFavorites';
import { getUserDetails } from '../../services/user/getUserDetails';
import utilityService from '../../services/utility.service';
import etdServiceService from '../../services/etd.service';
import AppConst from '../../constants/app.constant';
import menuService from '../../services/menu.service';
import ChartConst from '../../constants/chart.constant';
import EventConst from '../../constants/event.constant';
import router from '../../router';
import { routerPushInterface, routerReplaceInterface } from '../../services/router.interface';

const favoritesService = () => {
  const content = {};
  content.favoriteList = [];
  content.lockFavMarking = false;

  function getFavParams(settings) {
    const paramsAndKey = {
      params: {},
      key: `${router.currentRoute.value.name}:`,
    };
    switch (router.currentRoute.value.name) {
      case AppConst.stateMap.dashboard.key:
        paramsAndKey.params.start = settings.start;
        paramsAndKey.params.product = settings.product || ChartConst.defaultProduct;
        // If param is not available then use default actionKey
        paramsAndKey.params.actionKey = settings.actionKey || ChartConst.defaultAction;
        paramsAndKey.key += `${paramsAndKey.params.start}:${paramsAndKey.params.product}:${paramsAndKey.params.actionKey}`;
        paramsAndKey.key = paramsAndKey.key.toLowerCase();
        break;
      case AppConst.stateMap.routeprofile.key:
      case AppConst.stateMap.leafletmapview.key:
      case AppConst.stateMap.mapview.key:
      case AppConst.stateMap.gridview.key:
        paramsAndKey.params.start = settings.start;
        paramsAndKey.params.end = settings.end;
        paramsAndKey.params.departureTime = settings.departureTime;
        paramsAndKey.key += `${settings.start}:${settings.end}`;
        if (settings.mid1) {
          paramsAndKey.params.mid1 = settings.mid1;
          paramsAndKey.key += `:${settings.mid1}`;
        }
        if (settings.mid2) {
          paramsAndKey.params.mid2 = settings.mid2;
          paramsAndKey.key += `:${settings.mid2}`;
        }
        paramsAndKey.key = paramsAndKey.key.toLowerCase();
        break;
      case AppConst.stateMap.weather.key:
        paramsAndKey.params.start = settings.start;
        paramsAndKey.key += settings.start;
        paramsAndKey.key = paramsAndKey.key.toLowerCase();
        break;
      case AppConst.stateMap.avwxtab.key:
      case AppConst.stateMap.imagery.key:
        paramsAndKey.params.pathkey = settings.pathkey;
        paramsAndKey.params.pathkey2 = settings.pathkey2;
        paramsAndKey.params.subtab = settings.subtab;
        paramsAndKey.key2 = paramsAndKey.key;
        paramsAndKey.key += settings.pathkey;
        paramsAndKey.key = paramsAndKey.key.toLowerCase();
        paramsAndKey.key2 += settings.pathkey2;
        paramsAndKey.key2 = paramsAndKey.key2.toLowerCase();
        break;
      case AppConst.stateMap.workshops.key:
        paramsAndKey.params.workshop_directory = settings.workshop_directory;
        paramsAndKey.params.workshop_id = settings.workshop_id;
        paramsAndKey.params.title = settings.title;
        paramsAndKey.key += settings.workshop_directory;
        paramsAndKey.key = paramsAndKey.key.toLowerCase();
        break;
      default:
    }
    return paramsAndKey;
  }
  content.getFavoriteList = () => {
    const user = getUserDetails();
    content.favoriteList = [...user.favorites];
    return content.favoriteList;
  };
  content.setFavoriteList = async () => {
    const user = getUserDetails();
    setUserDetails({
      ...user,
      favorites: content.favoriteList,
    });
    Emitter.emit(EventConst.favorite.listRefreshed);
    await setUserFavorites(content.favoriteList);
    content.getFavoriteList();
  };
  content.checkAlreadyFavorite = (keyHash) => {
    let alreadyExistIndex = -1;
    let i = 0;
    if (content.favoriteList) {
      while (i < content.favoriteList.length) {
        if (content.favoriteList[i].key === keyHash || content.favoriteList[i].key2 === keyHash) {
          alreadyExistIndex = i;
          break;
        }
        i += 1;
      }
    }
    return alreadyExistIndex;
  };
  content.getIndexOfItemInFavList = (settings) => {
    let alreadyExistIndex = -1;
    if (settings) {
      const paramsAndKey = getFavParams(settings);
      alreadyExistIndex = content.checkAlreadyFavorite(paramsAndKey.key);
      if (alreadyExistIndex === -1 && paramsAndKey.key2) {
        alreadyExistIndex = content.checkAlreadyFavorite(paramsAndKey.key2);
      }
    }
    return alreadyExistIndex;
  };
  // content.updateDepartureTimeForFavItem = (newETD, settings) => {
  //   const idxOfFavItem = content.getIndexOfItemInFavList(settings);
  //   if (idxOfFavItem > -1) {
  //     content.favoriteList[idxOfFavItem].params.departureTime = newETD;
  //     content.setFavoriteList();
  //   }
  // };
  content.isMarkedFavorite = (settings) => {
    if (settings) {
      return !!(content.getIndexOfItemInFavList(settings) > -1);
    }
    return null;
  };
  content.isMarkedFavoriteCheckForStar = (vm, item) => {
    if (item) {
      if (content.isMarkedFavorite(item)) {
        vm.isMarkedFavorite = true;
      } else {
        vm.isMarkedFavorite = false;
      }
    }
  };
  content.addItemToFavoriteList = (settings) => {
    if (!settings) {
      // return if setting not available yet
      return;
    }
    const paramsAndKey = getFavParams(settings);
    const newFavItem = {
      key: paramsAndKey.key,
      params: paramsAndKey.params,
      stateName: router.currentRoute.value.name,
      logDate: new Date(),
    };
    if (paramsAndKey.key2) {
      newFavItem.key2 = paramsAndKey.key2;
    }
    let alreadyExistIndex = content.checkAlreadyFavorite(newFavItem.key);
    if (alreadyExistIndex === -1 && paramsAndKey.key2) {
      alreadyExistIndex = content.checkAlreadyFavorite(paramsAndKey.key2);
    }
    if (alreadyExistIndex > -1) {
      content.favoriteList.splice(alreadyExistIndex, 1);
    } else if (newFavItem.key.indexOf('undefined') < 0) {
      // There is no item in key as undefined
      content.favoriteList.push(newFavItem);
    }
    content.setFavoriteList();
    // Emitter.emit(EventConst.datasetSynced);
  };
  /**
   * This function takes departureTime string and returns departureTime if
   * it is greater then current time else it returns null
   * @param {dateString} favItemDepartureTime
   * @returns {Date || null}
   */
  content.getDepartureTimeForFavItem = function (favItemDepartureTime) {
    if (favItemDepartureTime) {
      favItemDepartureTime = new Date(favItemDepartureTime);
    }
    if (favItemDepartureTime && favItemDepartureTime > new Date()) {
      return favItemDepartureTime;
    }
    return null;
  };
  content.goToFav = (item) => {
    menuService.closeMenu();
    item.params.isFromFav = 'true';
    const temp = utilityService.clone(item.params);
    delete temp.subtab;
    // $location.path(item.stateName.replace(".", "/")).search(temp);
    if (
      router.currentRoute.value.name === 'app.mapview'
      || router.currentRoute.value.name === 'app.leafletmapview'
      || router.currentRoute.value.name === 'app.gridview'
      || router.currentRoute.value.name === 'app.routeprofile'
    ) {
      etdServiceService.setDepartureTime(
        content.getDepartureTimeForFavItem(item.params.departureTime),
      );
    }
    if (item.stateName && router.currentRoute.value.name === item.stateName) {
      routerPushInterface({
        query: item.params,
      });
      setTimeout(() => {
        Emitter.emit(EventConst.refreshViewRootscope + item.stateName);
      }, 10);
    } else {
      routerReplaceInterface({
        name: item.stateName,
        query: item.params,
      });
    }
  };
  content.markItemAsFav = (item) => {
    if (!content.lockFavMarking) {
      content.lockFavMarking = true;
      content.addItemToFavoriteList(item);
      // we dont have to do it here datasync event will sort it
      // vm.isMarkedFavorite = content.isMarkedFavorite(vm.settings);
      window.setTimeout(() => {
        content.lockFavMarking = false;
      }, 500);
    }
  };
  return content;
};
export default favoritesService();
